/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { GetDriversReportQueryParams, GetDriversReport200, GetDriversReport400, GetDriversReportQueryResponse } from '../entities/GetDriversReport'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { z } from 'zod'

export const getDriversReportQueryParamsSchema = z
  .object({
    active_last_45_days: z.boolean().optional(),
    drivee_city_id: z.number().int().optional(),
    drivee_id: z.number().int().optional(),
    no_orders_14_to_20_days: z.boolean().optional(),
    no_orders_14_to_45_days: z.boolean().optional(),
    no_orders_21_to_30_days: z.boolean().optional(),
    no_orders_31_to_45_days: z.boolean().optional(),
    phone: z.string().optional(),
    recruiter_id: z.string().optional(),
  })
  .optional() as unknown as ToZod<GetDriversReportQueryParams>

/**
 * @description Binary file
 */
export const getDriversReport200Schema = z.instanceof(File) as unknown as ToZod<GetDriversReport200>

/**
 * @description Bad Request
 */
export const getDriversReport400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<GetDriversReport400>

export const getDriversReportQueryResponseSchema = z.lazy(() => getDriversReport200Schema) as unknown as ToZod<GetDriversReportQueryResponse>